import { Fragment } from 'react'

import { m } from 'framer-motion'
import Image from 'next/image'
import { useTranslations } from 'next-intl'

import CocOnboardingImageScreen1 from '@/assets/images/clashofclans/onboarding-image-screen-1.webp'

import { getShortSlugNotHD } from '../../../../../../../fixtures/games'
import { useGameSlug } from '../../../../../game-provider'
import { variants } from '../../../constants'

import styles from './styles.module.scss'

export const Screen1 = () => {
  const t = useTranslations()
  const gameSlug = useGameSlug()
  const shortSlug = getShortSlugNotHD(gameSlug)

  return (
    <Fragment>
      <m.h1
        key="coc-screen-1-title"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.2, delay: 0.3, ease: 'easeInOut' }}
        className={styles.Title}
      >
        {t(`${shortSlug}_onboarding_welcome_to_store`)}
      </m.h1>
      <m.div
        key="coc-screen-1-image"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.2, delay: 0.2, ease: 'easeInOut' }}
        className={styles.ItemArea}
      >
        <div className={styles.ItemImage}>
          <Image src={CocOnboardingImageScreen1} alt="Clash of Clans Store" width={300} />
        </div>
      </m.div>
      <m.div
        key="coc-screen-1-footer"
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.2, delay: 0.1, ease: 'easeInOut' }}
        className={styles.BottomText}
      >
        <p>{t('onboarding_improvements')}</p>
      </m.div>
    </Fragment>
  )
}
